<hs-panel-card
  *ngIf="isCwOnly && !isMultipleSelected"
  header="No External Position Selected"
>
  <p>
    This panel requires a position row of the type EXTERNAL_ONLY or MATCHED to
    be selected in order for the data to be loaded.
  </p>
</hs-panel-card>

<hs-panel-card *ngIf="isMultipleSelected" header="Multiple Positions Selected">
  <p>
    This panel requires a single position row to be selected in order for the
    data to be loaded.
  </p>
</hs-panel-card>

<ng-container *ngIf="!isMultipleSelected && !isCwOnly">
  <ng-container>
    <nf-table-layout
      *nfLoader="isLoading"
      tableTitle="External Position Detail"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [data]="data"
      [autoResizeGrid]="false"
      hideTitle
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </ng-container>
</ng-container>
